import type { EventName } from "@lit/react";
import { Switch as SwitchElement, type SwitchEventMap as _SwitchEventMap, } from "@vaadin/switch/vaadin-switch.js";
import * as React from "react";
import { createThemedComponent, type WebComponentProps } from "../utils/createComponent.js";
export { SwitchElement };
export type SwitchEventMap = Readonly<{
    onChange: EventName<_SwitchEventMap["change"]>;
    onCheckedChanged: EventName<_SwitchEventMap["checked-changed"]>;
    onInvalidChanged: EventName<_SwitchEventMap["invalid-changed"]>;
    onValidated: EventName<_SwitchEventMap["validated"]>;
}>;
const events = { onChange: "change", onCheckedChanged: "checked-changed", onInvalidChanged: "invalid-changed", onValidated: "validated" } as SwitchEventMap;
export type SwitchProps = WebComponentProps<SwitchElement, SwitchEventMap> & {
    theme?: string;
};
export const Switch = createThemedComponent({
    elementClass: SwitchElement,
    events,
    react: React,
    tagName: "vaadin-switch",
});
